/* eslint-disable react/no-unescaped-entities */
import React from 'react'
import './Privacy.scss'

const Privacy = () => {
  return (
    <div className="privacy-container">
      <div className="WordSection1">
        <p className="MsoTitle">
          <a name="_na8qdw4647pu" />
          <span lang="EN">Privacy Policy</span>
        </p>
        <p className="MsoNormal">
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%' }}>
            &nbsp;
          </span>
        </p>
        <p className="MsoNormal">
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%' }}>
            Effective date: October 27, 2022
          </span>
        </p>
        <p className="MsoNormal">
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%' }}>
            &nbsp;
          </span>
        </p>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN">
            ChessX, Inc. ("us", "we", or "our") operates the chessx.app website and the chessx.app
            mobile application (the "Service").
          </span>
        </p>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN">
            This page informs you of our policies regarding the collection, use, and disclosure of
            personal data when you use our Service and the choices you have associated with that
            data. Our Privacy Policy is subject to our User Agreement and the other applicable
            agreements referenced therein.
          </span>
        </p>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN">
            We use your data to provide and improve the Service. By using the Service, you agree to
            the collection and use of information in accordance with this policy. Unless otherwise
            defined in this Privacy Policy, terms used in this Privacy Policy have the same meanings
            as in our Terms and Conditions.
          </span>
        </p>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <b>
            <span lang="EN">
              IMPORTANT NOTE TO RESIDENTS OF THE EUROPEAN UNION AND THE UNITED KINGDOM:{' '}
            </span>
          </b>
          <span lang="EN">
            This privacy policy contains important information about your rights under the General
            Data Protection Regulation of the European Union and the equivalent laws of the United
            Kingdom (the &quot;GDPR&quot;). Please see our GDPR Notice below for more information about these
            rights.
          </span>
        </p>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN">
            If you are subject to the General Data Protection Regulation (the &quot;GDPR&quot;), please see
            below for information regarding your right to exercise certain of your rights under the
            GDPR, including your &quot;right to be forgotten.&quot; If you are subject to the privacy laws of
            the State of California, including the California Consumer Privacy Act (the &quot;CCPA&quot;),
            please see below for information regarding your right to exercise certain of your rights
            under CCPA, including your right to instruct us not to sell your personal information.
          </span>
        </p>
        <h2 style={{ marginBottom: '.0001pt', pageBreakAfter: 'auto' }}>
          <a name="_4tkupqrki4wm" />
          <b>
            <span lang="EN" style={{ fontSize: '17.0pt', lineHeight: '115%' }}>
              Definitions
            </span>
          </b>
        </h2>
        <h3
          style={{
            marginTop: '14.0pt',
            marginRight: '0in',
            marginBottom: '.0001pt',
            marginLeft: '0in',
            pageBreakAfter: 'auto'
          }}
        >
          <a name="_f8buf5yc0ix" />
          <b>
            <span lang="EN" style={{ fontSize: '13.0pt', lineHeight: '115%', color: 'black' }}>
              Service
            </span>
          </b>
        </h3>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN">
            Service means the chessx.app website and the chessx.app mobile application operated by
            ChessX, Inc., and any other products or services that we extend through chessx.app or by
            other means. The Service does not include third-party content such as advertisements, or
            any other products or services offered by third parties. We do not and cannot control
            any third-party content, including user-generated content (for example, in-game chat
            content).
          </span>
        </p>
        <h3
          style={{
            marginTop: '14.0pt',
            marginRight: '0in',
            marginBottom: '.0001pt',
            marginLeft: '0in',
            pageBreakAfter: 'auto'
          }}
        >
          <a name="_ymdxbz84sfr3" />
          <b>
            <span lang="EN" style={{ fontSize: '13.0pt', lineHeight: '115%', color: 'black' }}>
              Personal Data
            </span>
          </b>
        </h3>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN">
            Personal Data means data about a living individual who can be identified from that data
            (or from that and other information either in our possession or likely to come into our
            possession). Personal data may also include &quot;pseudonymous&quot; data, meaning information
            about you which cannot be used to identify you personally - for example, an IP address,
            or information about which country from which you log into ChessX. For purposes of this
            Privacy Policy, all pseudonymous data is Personal Data to the extent that ChessX is a
            data processor of pseudonymous data.
          </span>
        </p>
        <h3
          style={{
            marginTop: '14.0pt',
            marginRight: '0in',
            marginBottom: '.0001pt',
            marginLeft: '0in',
            pageBreakAfter: 'auto'
          }}
        >
          <a name="_fdd97ryih0h3" />
          <b>
            <span lang="EN" style={{ fontSize: '13.0pt', lineHeight: '115%', color: 'black' }}>
              Usage Data
            </span>
          </b>
        </h3>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN">
            Usage Data is data collected automatically either generated by the use of the Service or
            from the Service infrastructure itself (for example, the duration of a page visit). User
            Data may include pseudonymous data where applicable.
          </span>
        </p>
        <h3
          style={{
            marginTop: '14.0pt',
            marginRight: '0in',
            marginBottom: '.0001pt',
            marginLeft: '0in',
            pageBreakAfter: 'auto'
          }}
        >
          <a name="_1eufe94zdhai" />
          <b>
            <span lang="EN" style={{ fontSize: '13.0pt', lineHeight: '115%', color: 'black' }}>
              Cookies
            </span>
          </b>
        </h3>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN">
            Cookies are small pieces of data stored on your device (computer or mobile device).
          </span>
        </p>
        <h3
          style={{
            marginTop: '14.0pt',
            marginRight: '0in',
            marginBottom: '.0001pt',
            marginLeft: '0in',
            pageBreakAfter: 'auto'
          }}
        >
          <a name="_t8linl9a3swx" />
          <b>
            <span lang="EN" style={{ fontSize: '13.0pt', lineHeight: '115%', color: 'black' }}>
              Data Controller
            </span>
          </b>
        </h3>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN">
            Data Controller means the natural or legal person who (either alone or jointly or in
            common with other persons) determines the purposes for which and the manner in which any
            personal information is, or is to be, processed. For the purpose of this Privacy Policy,
            we are a Data Controller of your Personal Data and of your Usage Data.
          </span>
        </p>
        <h3
          style={{
            marginTop: '14.0pt',
            marginRight: '0in',
            marginBottom: '.0001pt',
            marginLeft: '0in',
            pageBreakAfter: 'auto'
          }}
        >
          <a name="_jj0jx3f3alrv" />
          <b>
            <span lang="EN" style={{ fontSize: '13.0pt', lineHeight: '115%', color: 'black' }}>
              Data Processors (or Service Providers)
            </span>
          </b>
        </h3>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN">
            Data Processor means any natural or legal person, including Service Providers, who
            processes the data on behalf of the Data Controller. We may use the services of various
            Data Processors in order to process your data more effectively. Any third party
            specifically referenced in this Privacy Policy, including Google (Alphabet, Inc.) and
            Facebook (Facebook, Inc., d/b/a Meta) is a third-party Data Processor within the meaning
            of this Privacy Policy.
          </span>
        </p>
        <h3
          style={{
            marginTop: '14.0pt',
            marginRight: '0in',
            marginBottom: '.0001pt',
            marginLeft: '0in',
            pageBreakAfter: 'auto'
          }}
        >
          <a name="_ju54f0m34eak" />
          <b>
            <span lang="EN" style={{ fontSize: '13.0pt', lineHeight: '115%', color: 'black' }}>
              Data Subject (or User)
            </span>
          </b>
        </h3>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN">
            Data Subject is any living individual who is using our Service and is the subject of
            Personal Data.
          </span>
        </p>
        <h2 style={{ marginBottom: '.0001pt', pageBreakAfter: 'auto' }}>
          <a name="_s8igemyjt9w4" />
          <b>
            <span lang="EN" style={{ fontSize: '17.0pt', lineHeight: '115%' }}>
              Information Collection And Use
            </span>
          </b>
        </h2>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN">
            We collect several different types of information for various purposes to provide and
            improve our Service to you.
          </span>
        </p>
        <h2 style={{ marginBottom: '.0001pt', pageBreakAfter: 'auto' }}>
          <a name="_l6ek22cenh8d" />
          <b>
            <span lang="EN" style={{ fontSize: '17.0pt', lineHeight: '115%' }}>
              Types of Data Collected
            </span>
          </b>
        </h2>
        <h3
          style={{
            marginTop: '14.0pt',
            marginRight: '0in',
            marginBottom: '.0001pt',
            marginLeft: '0in',
            pageBreakAfter: 'auto'
          }}
        >
          <a name="_uka8tqjb1tmt" />
          <b>
            <span lang="EN" style={{ fontSize: '13.0pt', lineHeight: '115%', color: 'black' }}>
              Personal Data
            </span>
          </b>
        </h3>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN">
            While using our Service, we may ask you to provide us with certain personally
            identifiable information that can be used to contact or identify you ("Personal Data").
            Personally identifiable information may include, but is not limited to:
          </span>
        </p>
        <p className="MsoNormal" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span lang="EN">
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
            </span>
          </span>
          <span lang="EN">
            Required Information (chessx.app username and either an email address, Google public ID
            or Facebook public ID)
          </span>
        </p>
        <p className="MsoNormal" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span lang="EN">
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
            </span>
          </span>
          <span lang="EN">
            Optional Information (First name, last name, and other personal descriptors)
          </span>
        </p>
        <p className="MsoNormal" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span lang="EN">
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
            </span>
          </span>
          <span lang="EN">Cookies and Usage Data</span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: '0in',
            marginRight: '0in',
            marginBottom: '.25in',
            marginLeft: '.5in',
            textIndent: '-.25in'
          }}
        >
          <span lang="EN">
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
            </span>
          </span>
          <span lang="EN">
            Verification Information &quot; Should you choose to apply on our platform for Verification,
            you will be required to provide the following information: first and last name; date of
            birth; place of birth; country; and a valid email address.
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: '.5in',
            marginRight: '0in',
            marginBottom: '.25in',
            marginLeft: '0in',
            lineHeight: '150%'
          }}
        >
          <span lang="EN">
            We may use your Personal Data to contact you with newsletters, marketing or promotional
            materials and other information that may be of interest to you. We do not sell your
            Personal Data or your Usage Data. Such data is for internal marketing purposes only. If
            you access ChessX through a web browser, your web browser may collect information about
            you and use it for advertising purposes or other purposes outside of our control. We do
            not and cannot store, manipulate, transfer, or sell any data which is collected or used
            by your web browser.
          </span>
        </p>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN">
            If you use our App for the Android platform, we may ask, with your permission, to
            collect your contact list information (including potentially email addresses and phone
            numbers) to share with Google for the exclusive purpose of finding your friends and
            connections. We do not store this information. Similarly, if you use our App for the
            Apple platform, we may ask, with your permission, to collect your contact list
            information (including potentially email addresses and phone numbers) to share with
            Apple for the exclusive purpose of finding your friends and connections. We do not store
            this information.
          </span>
        </p>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN">
            You may opt out of receiving any, or all, of these communications from us by following
            the unsubscribe link or instructions provided in any email we send or by contacting us.
          </span>
        </p>
        <h3
          style={{
            marginTop: '14.0pt',
            marginRight: '0in',
            marginBottom: '.0001pt',
            marginLeft: '0in',
            pageBreakAfter: 'auto'
          }}
        >
          <a name="_6xuc747qchjm" />
          <b>
            <span lang="EN" style={{ fontSize: '13.0pt', lineHeight: '115%', color: 'black' }}>
              Usage Data
            </span>
          </b>
        </h3>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN">
            We may also collect information that your browser sends to us whenever you visit our
            Service or when you access the Service by or through a mobile device ("Usage Data").
          </span>
        </p>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN">
            This Usage Data may include information such as your computer's Internet Protocol
            address (e.g. IP address), browser type, browser version, the pages of our Service that
            you visit, the time and date of your visit, the time spent on those pages, unique device
            identifiers and other diagnostic data.
          </span>
        </p>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN">
            When you access the Service by or through a mobile device, this Usage Data may include
            information such as the type of mobile device you use, your mobile device unique ID, the
            IP address of your mobile device, your mobile operating system, the type of mobile
            Internet browser you use, unique device identifiers and other diagnostic data.
          </span>
        </p>
        <h3
          style={{
            marginTop: '14.0pt',
            marginRight: '0in',
            marginBottom: '.0001pt',
            marginLeft: '0in',
            pageBreakAfter: 'auto'
          }}
        >
          <a name="_2z8wz8shp75k" />
          <b>
            <span lang="EN" style={{ fontSize: '13.0pt', lineHeight: '115%', color: 'black' }}>
              Tracking Cookies Data
            </span>
          </b>
        </h3>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN">
            We use cookies and similar tracking technologies to track the activity on our Service
            and hold certain information.
          </span>
        </p>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN">
            Cookies are files with small amounts of data which may include an anonymous unique
            identifier. Cookies are sent to your browser from a website and stored on your device.
            Tracking technologies also used are beacons, tags, and scripts to collect and track
            information and to improve and analyze our Service.
          </span>
        </p>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN">
            You can instruct your browser to refuse all cookies or to indicate when a cookie is
            being sent. However, if you do not accept cookies, you may not be able to use some
            portions of our Service. Any Service, including paid Services or subscriptions to
            ChessX, may become unstable and non-functional if you do not accept cookies from ChessX.
          </span>
        </p>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN">Examples of Cookies we use:</span>
        </p>
        <p className="MsoNormal" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span lang="EN">
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
            </span>
          </span>
          <b>
            <span lang="EN">Session Cookies</span>
          </b>
          <span lang="EN">. We use Session Cookies to keep you logged into our Service.</span>
        </p>
        <p className="MsoNormal" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span lang="EN">
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
            </span>
          </span>
          <b>
            <span lang="EN">Preference Cookies.</span>
          </b>
          <span lang="EN">
            {' '}
            We use Preference Cookies to remember your preferences and various settings.
          </span>
        </p>
        <p className="MsoNormal" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span lang="EN">
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
            </span>
          </span>
          <b>
            <span lang="EN">Security Cookies.</span>
          </b>
          <span lang="EN"> We use Security Cookies for security purposes.</span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: '0in',
            marginRight: '0in',
            marginBottom: '.25in',
            marginLeft: '.5in',
            textIndent: '-.25in'
          }}
        >
          <span lang="EN">
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
            </span>
          </span>
          <b>
            <span lang="EN">Advertising Cookies.</span>
          </b>
          <span lang="EN">
            {' '}
            Advertising Cookies are used to serve you with advertisements that may be relevant to
            you and your interests. You may opt out of the use of these cookies by visiting the
            Google ad and content network privacy policy at{' '}
            <span style={{ color: '#1155CC' }}>
              <a href="http://www.privacychoice.org/companies">
                <span style={{ color: '#1155CC', textDecoration: 'none' }}>
                  http://www.privacychoice.org/companies
                </span>
              </a>
            </span>
            or{' '}
            <span style={{ color: '#1155CC' }}>
              <a href="http://www.aboutads.info/choices">
                <span style={{ color: '#1155CC', textDecoration: 'none' }}>
                  http://www.aboutads.info/choices
                </span>
              </a>
            </span>
            . To learn more about this behavioral advertising practice or to opt-out of this type of
            advertising, you can visit{' '}
            <span style={{ color: '#1155CC' }}>
              <a href="http://www.networkadvertising.org/">
                <span style={{ color: '#1155CC', textDecoration: 'none' }}>
                  www.networkadvertising.org
                </span>
              </a>
            </span>
            . Google is a third-party Data Processor over whom we have no control. We do not and
            cannot manage or control any data that Google processes on your behalf.
          </span>
        </p>
        <h2 style={{ marginBottom: '.0001pt', pageBreakAfter: 'auto' }}>
          <a name="_8o1lovwj6ax" />
          <b>
            <span lang="EN" style={{ fontSize: '17.0pt', lineHeight: '115%' }}>
              Use of Data
            </span>
          </b>
        </h2>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN">ChessX, Inc. uses the collected data for various purposes:</span>
        </p>
        <p className="MsoNormal" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span lang="EN">
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
            </span>
          </span>
          <span lang="EN">To customize the advertising and content you see</span>
        </p>
        <p className="MsoNormal" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span lang="EN">
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
            </span>
          </span>
          <span lang="EN">To provide and maintain our Service</span>
        </p>
        <p className="MsoNormal" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span lang="EN">
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
            </span>
          </span>
          <span lang="EN">To notify you about changes to our Service</span>
        </p>
        <p className="MsoNormal" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span lang="EN">
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
            </span>
          </span>
          <span lang="EN">
            To allow you to participate in interactive features of our Service when you choose to do
            so
          </span>
        </p>
        <p className="MsoNormal" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span lang="EN">
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
            </span>
          </span>
          <span lang="EN">To provide customer support</span>
        </p>
        <p className="MsoNormal" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span lang="EN">
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
            </span>
          </span>
          <span lang="EN">
            To gather analysis or valuable information so that we can improve our Service
          </span>
        </p>
        <p className="MsoNormal" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span lang="EN">
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
            </span>
          </span>
          <span lang="EN">To monitor the usage of our Service</span>
        </p>
        <p className="MsoNormal" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span lang="EN">
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
            </span>
          </span>
          <span lang="EN">To detect, prevent and address technical issues</span>
        </p>
        <p className="MsoNormal" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span lang="EN">
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
            </span>
          </span>
          <span lang="EN">
            To provide you with news, special offers and general information about other goods,
            services and events which we offer that are similar to those that you have already
            purchased or enquired about unless you have opted not to receive such information
          </span>
        </p>
        <p className="MsoNormal" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span lang="EN">
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
            </span>
          </span>
          <span lang="EN">
            To conduct research, and provide aggregated, anonymized reporting about our general user
            community for internal and external clients.
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: '0in',
            marginRight: '0in',
            marginBottom: '.25in',
            marginLeft: '.5in',
            textIndent: '-.25in'
          }}
        >
          <span lang="EN">
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
            </span>
          </span>
          <span lang="EN">
            Verification Information &quot; Should you choose to apply on our platform for Verification,
            we will store the information you provide in support of your application, and use that
            information to verify your identity.
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: '.5in',
            marginRight: '0in',
            marginBottom: '.25in',
            marginLeft: '0in',
            lineHeight: '150%'
          }}
        >
          <span lang="EN">We do not sell your Personal Data to third parties.</span>
        </p>
        <h2 style={{ marginBottom: '.0001pt', pageBreakAfter: 'auto' }}>
          <a name="_s12tekjww5ed" />
          <b>
            <span lang="EN" style={{ fontSize: '17.0pt', lineHeight: '115%' }}>
              Legal Basis for Processing Personal Data Under General Data Protection Regulation
              (GDPR)
            </span>
          </b>
        </h2>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN">
            If you are from the European Economic Area (EEA), ChessX, Inc.&quot;s legal basis for
            collecting and using the personal information described in this Privacy Policy depends
            on the Personal Data we collect and the specific context in which we collect it.
          </span>
        </p>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN">
            The purpose of this section of this policy is to explain how we ensure your privacy,
            what steps we take to prevent and mitigate the compromise of private information, what
            kinds of information we collect from you, what we do with that information, and how you
            may exercise certain of your rights under applicable data privacy laws related to that
            information. This policy identifies our data protection officer, and provides you with
            the information that you may need to contact our data protection officer.
          </span>
        </p>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN">
            All terms of this Policy and our Terms of Use apply whether you log in via a browser or
            through an app native to a mobile device or any other device. Browser-based logins may
            be further subject to the terms of service (however styled) of your chosen browser. When
            using a browser-based login, your browser is a third-party within the meaning of the
            GDPR. When using our mobile app, your native app store, cell phone provider, data
            carrier, or other third parties may be third-party Data Collectors within the meaning of
            this Privacy Policy. We do not and cannot collect or store information that you submit
            to your web browser but not to us (for example, if you enter text into a text field on a
            browser-based login page, but do not click the Submit button or otherwise execute a
            command to send that information to us).
          </span>
        </p>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN">ChessX, Inc. may process your Personal Data because:</span>
        </p>
        <p className="MsoNormal" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span lang="EN">
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
            </span>
          </span>
          <span lang="EN">We need to perform a contract with you</span>
        </p>
        <p className="MsoNormal" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span lang="EN">
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
            </span>
          </span>
          <span lang="EN">You have given us permission to do so</span>
        </p>
        <p className="MsoNormal" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span lang="EN">
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
            </span>
          </span>
          <span lang="EN">For payment processing purposes</span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: '0in',
            marginRight: '0in',
            marginBottom: '.25in',
            marginLeft: '.5in',
            textIndent: '-.25in'
          }}
        >
          <span lang="EN">
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
            </span>
          </span>
          <span lang="EN">To comply with the law</span>
        </p>
        <h2 style={{ marginBottom: '.0001pt', pageBreakAfter: 'auto' }}>
          <a name="_wmaz6sc4t8w8" />
          <b>
            <span lang="EN" style={{ fontSize: '17.0pt', lineHeight: '115%' }}>
              Retention of Data
            </span>
          </b>
        </h2>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN">
            ChessX, Inc. will retain your Personal Data only for as long as is necessary for the
            purposes set out in this Privacy Policy. We will retain and use your Personal Data to
            the extent necessary to comply with our legal obligations (for example, if we are
            required to retain your data to comply with applicable laws), resolve disputes, and
            enforce our legal agreements and policies, or until you instruct us to do otherwise in a
            fashion consistent with your rights (and our obligations) under the GDPR.
          </span>
        </p>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN">
            ChessX, Inc. will also retain Usage Data for internal analysis purposes. Usage Data is
            generally retained for a shorter period of time, except when this data is used to
            strengthen the security or to improve the functionality of our Service, or we are
            legally obligated to retain this data for longer time periods.
          </span>
        </p>
        <h2 style={{ marginBottom: '.0001pt', pageBreakAfter: 'auto' }}>
          <a name="_2s2ohy1yz0c6" />
          <b>
            <span lang="EN" style={{ fontSize: '17.0pt', lineHeight: '115%' }}>
              Transfer Of Data
            </span>
          </b>
        </h2>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN">
            Your information, including Personal Data, may be transferred to &quot; and maintained on &quot;
            computers located outside of your state, province, country or other governmental
            jurisdiction where the data protection laws may differ than those from your
            jurisdiction.
          </span>
        </p>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN">
            If you are located outside the United States and choose to provide information to us,
            please note that we transfer the data, including Personal Data, to the United States and
            process it there.
          </span>
        </p>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <b>
            <span lang="EN">
              Your consent to this Privacy Policy followed by your submission of such information
              represents your agreement to that transfer.
            </span>
          </b>
        </p>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN">
            ChessX, Inc. will take all steps reasonably necessary to ensure that your data is
            treated securely and in accordance with this Privacy Policy and no transfer of your
            Personal Data will take place to an organization or a country unless there are adequate
            controls in place including the security of your data and other personal information.
          </span>
        </p>
        <h2 style={{ marginBottom: '.0001pt', pageBreakAfter: 'auto' }}>
          <a name="_k9lq454ms5nm" />
          <b>
            <span lang="EN" style={{ fontSize: '17.0pt', lineHeight: '115%' }}>
              Disclosure Of Data
            </span>
          </b>
        </h2>
        <h3
          style={{
            marginTop: '14.0pt',
            marginRight: '0in',
            marginBottom: '.0001pt',
            marginLeft: '0in',
            pageBreakAfter: 'auto'
          }}
        >
          <a name="_xco29tpepitt" />
          <b>
            <span lang="EN" style={{ fontSize: '13.0pt', lineHeight: '115%', color: 'black' }}>
              Business Transaction
            </span>
          </b>
        </h3>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN">
            If ChessX, Inc. is involved in a merger, acquisition or asset sale, your Personal Data
            may be transferred. We will provide notice before your Personal Data is transferred and
            becomes subject to a different Privacy Policy.
          </span>
        </p>
        <h3
          style={{
            marginTop: '14.0pt',
            marginRight: '0in',
            marginBottom: '.0001pt',
            marginLeft: '0in',
            pageBreakAfter: 'auto'
          }}
        >
          <a name="_5slj7osz3yv7" />
          <b>
            <span lang="EN" style={{ fontSize: '13.0pt', lineHeight: '115%', color: 'black' }}>
              Disclosure for Law Enforcement
            </span>
          </b>
        </h3>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN">
            Under certain circumstances, ChessX, Inc. may be required to disclose your Personal Data
            if required to do so by law or in response to valid requests by public authorities (e.g.
            a court or a government agency).
          </span>
        </p>
        <h3
          style={{
            marginTop: '14.0pt',
            marginRight: '0in',
            marginBottom: '.0001pt',
            marginLeft: '0in',
            pageBreakAfter: 'auto'
          }}
        >
          <a name="_gn87hd7o3vpi" />
          <b>
            <span lang="EN" style={{ fontSize: '13.0pt', lineHeight: '115%', color: 'black' }}>
              Legal Requirements
            </span>
          </b>
        </h3>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN">
            ChessX, Inc. may disclose your Personal Data in the good faith belief that such action
            is necessary to:
          </span>
        </p>
        <p className="MsoNormal" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span lang="EN">
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
            </span>
          </span>
          <span lang="EN">To comply with a legal obligation</span>
        </p>
        <p className="MsoNormal" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span lang="EN">
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
            </span>
          </span>
          <span lang="EN">To protect and defend the rights or property of ChessX, Inc.</span>
        </p>
        <p className="MsoNormal" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span lang="EN">
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
            </span>
          </span>
          <span lang="EN">
            To prevent or investigate possible wrongdoing in connection with the Service
          </span>
        </p>
        <p className="MsoNormal" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span lang="EN">
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
            </span>
          </span>
          <span lang="EN">
            To protect the personal safety of users of the Service or the public
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: '0in',
            marginRight: '0in',
            marginBottom: '.25in',
            marginLeft: '.5in',
            textIndent: '-.25in'
          }}
        >
          <span lang="EN">
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
            </span>
          </span>
          <span lang="EN">To protect against legal liability</span>
        </p>
        <h2 style={{ marginBottom: '.0001pt', pageBreakAfter: 'auto' }}>
          <a name="_bemi38t5yr9r" />
          <b>
            <span lang="EN" style={{ fontSize: '17.0pt', lineHeight: '115%' }}>
              Security Of Data
            </span>
          </b>
        </h2>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN">
            The security of your data is important to us, but remember that no method of
            transmission over the Internet, or method of electronic storage is 100% secure. While we
            strive to use commercially acceptable means to protect your Personal Data, we cannot
            guarantee its absolute security.
          </span>
        </p>
        <h2 style={{ marginBottom: '.0001pt', pageBreakAfter: 'auto' }}>
          <a name="_p1yt3il0mu1o" />
          <b>
            <span lang="EN" style={{ fontSize: '17.0pt', lineHeight: '115%' }}>
              "Do Not Track" Signals
            </span>
          </b>
        </h2>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN">
            We do not support Do Not Track ("DNT"). Do Not Track is a preference you can set in your
            web browser to inform websites that you do not want to be tracked.
          </span>
        </p>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN">
            You can enable or disable Do Not Track by visiting the Preferences or Settings page of
            your web browser. If you enable DNT functionality on any device, certain of the
            Services, including paid Services or ChessX subscriptions, may become unstable.
          </span>
        </p>
        <h2 style={{ marginBottom: '.0001pt', pageBreakAfter: 'auto' }}>
          <a name="_p055avgq61ly" />
          <b>
            <span lang="EN" style={{ fontSize: '17.0pt', lineHeight: '115%' }}>
              Your Data Protection Rights Under General Data Protection Regulation (GDPR)
            </span>
          </b>
        </h2>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN">
            If you are a resident of the European Economic Area (EEA), you have certain data
            protection rights. ChessX, Inc. aims to take reasonable steps to allow you to correct,
            amend, delete, or limit the use of your Personal Data.
          </span>
        </p>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN">
            If you wish to be informed what Personal Data we hold about you and if you want it to be
            removed from our systems, please contact us.
          </span>
        </p>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN">
            You can edit your ChessX account information at any time. In certain circumstances, you
            have the following data protection rights:
          </span>
        </p>
        <p className="MsoNormal" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span lang="EN">
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
            </span>
          </span>
          <b>
            <span lang="EN">
              The right to access, update or to delete the information we have on you.
            </span>
          </b>
          <span lang="EN">
            {' '}
            Whenever made possible, you can access, update or request deletion of your Personal Data
            directly within your account settings section. If you are unable to perform these
            actions yourself, please contact us to assist you.
          </span>
        </p>
        <p className="MsoNormal" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span lang="EN">
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
            </span>
          </span>
          <b>
            <span lang="EN">The right of rectification.</span>
          </b>
          <span lang="EN">
            {' '}
            You have the right to have your information rectified if that information is inaccurate
            or incomplete.
          </span>
        </p>
        <p className="MsoNormal" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span lang="EN">
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
            </span>
          </span>
          <b>
            <span lang="EN">The right to object.</span>
          </b>
          <span lang="EN">
            {' '}
            You have the right to object to our processing of your Personal Data.
          </span>
        </p>
        <p className="MsoNormal" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span lang="EN">
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
            </span>
          </span>
          <b>
            <span lang="EN">The right of restriction.</span>
          </b>
          <span lang="EN">
            {' '}
            You have the right to request that we restrict the processing of your personal
            information.
          </span>
        </p>
        <p className="MsoNormal" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span lang="EN">
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
            </span>
          </span>
          <b>
            <span lang="EN">The right to data portability.</span>
          </b>
          <span lang="EN">
            {' '}
            You have the right to be provided with a copy of the information we have on you in a
            structured, machine-readable and commonly used format.
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: '0in',
            marginRight: '0in',
            marginBottom: '.25in',
            marginLeft: '.5in',
            textIndent: '-.25in'
          }}
        >
          <span lang="EN">
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
            </span>
          </span>
          <b>
            <span lang="EN">The right to withdraw consent.</span>
          </b>
          <span lang="EN">
            {' '}
            You also have the right to withdraw your consent at any time where ChessX, Inc. relied
            on your consent to process your personal information.
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: '.5in',
            marginRight: '0in',
            marginBottom: '.25in',
            marginLeft: '0in',
            lineHeight: '150%'
          }}
        >
          <span lang="EN">
            Please note that we may ask you to verify your identity before responding to such
            requests.
          </span>
        </p>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN">
            You have the right to complain to a Data Protection Authority about our collection and
            use of your Personal Data. For more information, please contact your local data
            protection authority in the European Economic Area (EEA).
          </span>
        </p>
        <h2 style={{ marginBottom: '.0001pt', pageBreakAfter: 'auto' }}>
          <a name="_cmpsrcavp6t8" />
          <b>
            <span lang="EN" style={{ fontSize: '17.0pt', lineHeight: '115%' }}>
              Service Providers
            </span>
          </b>
        </h2>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN">
            We may employ third party companies and individuals to facilitate our Service ("Service
            Providers"), including Data Processors, to provide the Service on our behalf, to perform
            Service-related services or to assist us in analyzing how our Service is used.
          </span>
        </p>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN">
            These third parties have access to your Personal Data only to perform these tasks on our
            behalf and are obligated not to disclose or use it for any other purpose.
          </span>
        </p>
        <h2 style={{ marginBottom: '.0001pt', pageBreakAfter: 'auto' }}>
          <a name="_upru0dt7c83q" />
          <b>
            <span lang="EN" style={{ fontSize: '17.0pt', lineHeight: '115%' }}>
              Analytics
            </span>
          </b>
        </h2>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN">
            We may use third-party Service Providers to monitor and analyze the use of our Service.
          </span>
        </p>
        <h3
          style={{
            marginTop: '14.0pt',
            marginRight: '0in',
            marginBottom: '.0001pt',
            marginLeft: '0in',
            pageBreakAfter: 'auto'
          }}
        >
          <a name="_g0abeula9l4u" />
          <b>
            <span lang="EN" style={{ fontSize: '13.0pt', lineHeight: '115%', color: 'black' }}>
              Amplitude
            </span>
          </b>
        </h3>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN">
            Amplitude is a web analytics service that tracks and reports website traffic. It uses
            the data collected to track and monitor the use of our Service. For more information
            about Amplitude, including how to exercise your rights under the GDPR or the CCPA,
            please contact Amplitude directly at{' '}
            <span style={{ color: '#1155CC' }}>
              <a href="https://amplitude.com/contact/general">
                <span style={{ color: '#1155CC', textDecoration: 'none' }}>
                  https://amplitude.com/contact/general
                </span>
              </a>
            </span>
            . Amplitude is a third-party Data Processor within the meaning of this Privacy Policy.
          </span>
        </p>
        <h2 style={{ marginBottom: '.0001pt', pageBreakAfter: 'auto' }}>
          <a name="_aiupcc8gq7yl" />
          <b>
            <span lang="EN" style={{ fontSize: '17.0pt', lineHeight: '115%' }}>
              Advertising
            </span>
          </b>
        </h2>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN">
            We may use third-party Service Providers to show advertisements to you to help support
            and maintain our Service.
          </span>
        </p>
        <h3
          style={{
            marginTop: '14.0pt',
            marginRight: '0in',
            marginBottom: '.0001pt',
            marginLeft: '0in',
            pageBreakAfter: 'auto'
          }}
        >
          <a name="_xsdyguwk8mvx" />
          <b>
            <span lang="EN" style={{ fontSize: '13.0pt', lineHeight: '115%', color: 'black' }}>
              Google AdSense DoubleClick Cookie
            </span>
          </b>
        </h3>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN">
            Google, as a third party vendor, uses cookies to serve ads on our Service. Google's use
            of the DoubleClick cookie enables it and its partners to serve ads to our users based on
            their visit to our Service or other websites on the Internet.
          </span>
        </p>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN">
            You may opt out of the use of the DoubleClick Cookie for interest-based advertising by
            visiting the Google Ads Settings web page:{' '}
            <span style={{ color: '#1155CC' }}>
              <a href="http://www.google.com/ads/preferences/">
                <span style={{ color: '#1155CC', textDecoration: 'none' }}>
                  http://www.google.com/ads/preferences
                </span>
              </a>
            </span>
            .
          </span>
        </p>
        <h2 style={{ marginBottom: '.0001pt', pageBreakAfter: 'auto' }}>
          <a name="_7zkjnizmoxq" />
          <b>
            <span lang="EN" style={{ fontSize: '17.0pt', lineHeight: '115%' }}>
              Payments
            </span>
          </b>
        </h2>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN">
            We may provide paid products and/or services within the Service. In that case, we use
            third-party services for payment processing (e.g. payment processors).
          </span>
        </p>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN">
            We will not store or collect your payment card details. That information is provided
            directly to our third-party payment processors whose use of your personal information is
            governed by their Privacy Policy. These payment processors adhere to the standards set
            by PCI-DSS as managed by the PCI Security Standards Council, which is a joint effort of
            brands like Visa, Mastercard, American Express and Discover. PCI-DSS requirements help
            ensure the secure handling of payment information.
          </span>
        </p>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN">The payment processors we work with are:</span>
        </p>
        <h3
          style={{
            marginTop: '14.0pt',
            marginRight: '0in',
            marginBottom: '.0001pt',
            marginLeft: '0in',
            pageBreakAfter: 'auto'
          }}
        >
          <a name="_szdb9vie8qld" />
          <b>
            <span lang="EN" style={{ fontSize: '13.0pt', lineHeight: '115%', color: 'black' }}>
              Apple Store In-App Payments
            </span>
          </b>
        </h3>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN">
            Their Privacy Policy can be viewed at{' '}
            <span style={{ color: '#1155CC' }}>
              <a href="https://www.apple.com/legal/privacy/en-ww/">
                <span style={{ color: '#1155CC', textDecoration: 'none' }}>
                  https://www.apple.com/legal/privacy/en-ww
                </span>
              </a>
            </span>
          </span>
        </p>
        <h3
          style={{
            marginTop: '14.0pt',
            marginRight: '0in',
            marginBottom: '.0001pt',
            marginLeft: '0in',
            pageBreakAfter: 'auto'
          }}
        >
          <a name="_f773q3cx34ui" />
          <b>
            <span lang="EN" style={{ fontSize: '13.0pt', lineHeight: '115%', color: 'black' }}>
              Google Play In-App Payments
            </span>
          </b>
        </h3>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN">
            Their Privacy Policy can be viewed at{' '}
            <span style={{ color: '#1155CC' }}>
              <a href="https://www.google.com/policies/privacy/">
                <span style={{ color: '#1155CC', textDecoration: 'none' }}>
                  https://www.google.com/policies/privacy
                </span>
              </a>
            </span>
          </span>
        </p>
        <h3
          style={{
            marginTop: '14.0pt',
            marginRight: '0in',
            marginBottom: '.0001pt',
            marginLeft: '0in',
            pageBreakAfter: 'auto'
          }}
        >
          <a name="_nffaocl0s4f6" />
          <b>
            <span lang="EN" style={{ fontSize: '13.0pt', lineHeight: '115%', color: 'black' }}>
              Adyen
            </span>
          </b>
        </h3>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN">
            Their Privacy Policy can be viewed at{' '}
            <span style={{ color: '#1155CC' }}>
              <a href="https://docs.adyen.com/legal/terms-conditions">
                <span style={{ color: '#1155CC', textDecoration: 'none' }}>
                  https://docs.adyen.com/legal/terms-conditions
                </span>
              </a>
            </span>
          </span>
        </p>
        <h3
          style={{
            marginTop: '14.0pt',
            marginRight: '0in',
            marginBottom: '.0001pt',
            marginLeft: '0in',
            pageBreakAfter: 'auto'
          }}
        >
          <a name="_dfh7zmo5dxcd" />
          <b>
            <span lang="EN" style={{ fontSize: '13.0pt', lineHeight: '115%', color: 'black' }}>
              PayPal
            </span>
          </b>
        </h3>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN">
            Their Privacy Policy can be viewed at{' '}
            <span style={{ color: '#1155CC' }}>
              <a href="https://www.paypal.com/webapps/mpp/ua/privacy-full">
                <span style={{ color: '#1155CC', textDecoration: 'none' }}>
                  https://www.paypal.com/webapps/mpp/ua/privacy-full
                </span>
              </a>
            </span>
          </span>
        </p>
        <h2 style={{ marginBottom: '.0001pt', pageBreakAfter: 'auto' }}>
          <a name="_nom3r2d80rv" />
          <b>
            <span lang="EN" style={{ fontSize: '17.0pt', lineHeight: '115%' }}>
              Appointment of the Data Protection Officer
            </span>
          </b>
        </h2>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN">
            ChessX&quot;s GDPR Data Protection Officer is Arun Mehta (the &quot;Protection Officer&quot;). The
            Protection Officer may be contacted at:
          </span>
        </p>
        <p className="MsoNormal">
          <b>
            <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%' }}>
              Phone:
            </span>
          </b>
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%' }}>
            {' '}
            1 (857) 222-6262
          </span>
        </p>
        <p className="MsoNormal">
          <b>
            <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%' }}>
              Email:
            </span>
          </b>
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%' }}>
            {' '}
            contact@chessx.app
          </span>
        </p>
        <p className="MsoNormal">
          <b>
            <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%' }}>
              Postal Address:
            </span>
          </b>
        </p>
        <p className="MsoNormal">
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%' }}>
            ChessX, Inc.
          </span>
        </p>
        <p className="MsoNormal">
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%' }}>
            137 Erie Street
          </span>
        </p>
        <p className="MsoNormal">
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%' }}>
            Cambridge, MA 02139
          </span>
        </p>
        <h2 style={{ marginBottom: '.0001pt', pageBreakAfter: 'auto' }}>
          <a name="_99wgl5907844" />
          <b>
            <span lang="EN" style={{ fontSize: '17.0pt', lineHeight: '115%' }}>
              Links To Other Sites
            </span>
          </b>
        </h2>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN">
            Our Service may contain links to other sites that are not operated by us. If you click
            on a third party link, you will be directed to that third party's site. We strongly
            advise you to review the Privacy Policy of every site you visit.
          </span>
        </p>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN">
            We have no control over and assume no responsibility for the content, privacy policies
            or practices of any third party sites or services.
          </span>
        </p>
        <h2 style={{ marginBottom: '.0001pt', pageBreakAfter: 'auto' }}>
          <a name="_3sqa92baxnpr" />
          <b>
            <span lang="EN" style={{ fontSize: '17.0pt', lineHeight: '115%' }}>
              Children's Privacy
            </span>
          </b>
        </h2>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN">
            ChessX does not target anyone under the age of 18 ("Children") for use of our Service.
          </span>
        </p>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN">
            We do not knowingly collect personally identifiable information from anyone under the
            age of 18. If you are a parent or guardian and you are aware that your Children has
            provided us with Personal Data, please contact us. If we become aware that we have
            collected Personal Data from children without verification of parental consent, we take
            steps to remove that information from our servers.
          </span>
        </p>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN">
            If you are a resident of the State of California or otherwise subject to the CCPA,
            please see below for important information regarding the privacy rights of Children
            using chessx.app or any of the Services. If you are under the age of 13 and a resident
            of the State of California, you may not use chessx.app or any of the Services.
          </span>
        </p>
        <h2 style={{ marginBottom: '.0001pt', pageBreakAfter: 'auto' }}>
          <a name="_yv2avpraieiv" />
          <b>
            <span lang="EN" style={{ fontSize: '17.0pt', lineHeight: '115%' }}>
              PRIVACY NOTICE FOR CALIFORNIA RESIDENTS
            </span>
          </b>
        </h2>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN">
            This
            <b>Privacy Notice for California Residents</b> supplements the information contained in
            our Privacy Policy and applies solely to all visitors, users and others who reside in
            the State of California. We adopt this notice to comply with the California Consumer
            Privacy Act of 2018 (CCPA). Any terms defined in the CCPA have the same meaning when
            used in this notice.
          </span>
        </p>
        <h3
          style={{
            marginTop: '14.0pt',
            marginRight: '0in',
            marginBottom: '.0001pt',
            marginLeft: '0in',
            pageBreakAfter: 'auto'
          }}
        >
          <a name="_ezv540hx32u6" />
          <b>
            <span lang="EN" style={{ fontSize: '13.0pt', lineHeight: '115%', color: 'black' }}>
              Your Rights and Choices
            </span>
          </b>
        </h3>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN">
            The CCPA provides consumers (California residents) with specific rights regarding their
            personal information. For purposes of the <b>Privacy Notice for California Residents</b>
            , personal information includes "
            <span style={{ color: '#1155CC' }}>
              <a href="https://www.chess.com/legal/privacy#personal_data">
                <span style={{ color: '#1155CC', textDecoration: 'none' }}>Personal Data</span>
              </a>
            </span>
            ", "
            <span style={{ color: '#1155CC' }}>
              <a href="https://www.chess.com/legal/privacy#usage_data">
                <span style={{ color: '#1155CC', textDecoration: 'none' }}>Usage Data</span>
              </a>
            </span>
            ", and "
            <span style={{ color: '#1155CC' }}>
              <a href="https://www.chess.com/legal/privacy#cookies">
                <span style={{ color: '#1155CC', textDecoration: 'none' }}>Cookies</span>
              </a>
            </span>
            " as those terms are defined in this Privacy Policy. This section describes your CCPA
            rights and explains how to exercise those rights.
          </span>
        </p>
        <h3
          style={{
            marginTop: '14.0pt',
            marginRight: '0in',
            marginBottom: '.0001pt',
            marginLeft: '0in',
            pageBreakAfter: 'auto'
          }}
        >
          <a name="_4nj41amk6na8" />
          <b>
            <span lang="EN" style={{ fontSize: '13.0pt', lineHeight: '115%', color: 'black' }}>
              Access to Specific Information and Data Portability Rights
            </span>
          </b>
        </h3>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN">
            You have the right to request that we disclose certain information to you about our
            collection and use of your personal information over the past 12 months that is not
            otherwise subject to an exception under the CCPA.
          </span>
        </p>
        <h3
          style={{
            marginTop: '14.0pt',
            marginRight: '0in',
            marginBottom: '.0001pt',
            marginLeft: '0in',
            pageBreakAfter: 'auto'
          }}
        >
          <a name="_n9ydsxm5wiu6" />
          <b>
            <span lang="EN" style={{ fontSize: '13.0pt', lineHeight: '115%', color: 'black' }}>
              Deletion Request Rights
            </span>
          </b>
        </h3>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN">
            You also have the right to request that we delete any of your personal information that
            we collected from you and retained, subject to certain exceptions.
          </span>
        </p>
        <h3
          style={{
            marginTop: '14.0pt',
            marginRight: '0in',
            marginBottom: '.0001pt',
            marginLeft: '0in',
            pageBreakAfter: 'auto'
          }}
        >
          <a name="_w7uw12moi190" />
          <b>
            <span lang="EN" style={{ fontSize: '13.0pt', lineHeight: '115%', color: 'black' }}>
              Exercising Access, Data Portability, and Deletion Rights
            </span>
          </b>
        </h3>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN">
            To exercise the access, data portability, and deletion rights described above, please
            submit a verifiable consumer request to us by:
          </span>
        </p>
        <p className="MsoNormal">
          <b>
            <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%' }}>
              Phone:
            </span>
          </b>
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%' }}>
            {' '}
            1 (857) 222-6262
          </span>
        </p>
        <p className="MsoNormal">
          <b>
            <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%' }}>
              Email:
            </span>
          </b>
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%' }}>
            {' '}
            contact@chessx.app
          </span>
        </p>
        <p className="MsoNormal">
          <b>
            <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%' }}>
              Postal Address:
            </span>
          </b>
        </p>
        <p className="MsoNormal">
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%' }}>
            ChessX, Inc.
          </span>
        </p>
        <p className="MsoNormal">
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%' }}>
            137 Erie Street
          </span>
        </p>
        <p className="MsoNormal">
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%' }}>
            Cambridge, MA 02139
          </span>
        </p>
        <p className="MsoNormal">
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%' }}>
            &nbsp;
          </span>
        </p>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN">To be verifiable your request must:</span>
        </p>
        <p className="MsoNormal" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span lang="EN">
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
            </span>
          </span>
          <span lang="EN">
            Provide sufficient information that allows us to reasonably verify you are the person
            about whom we collected personal information or an authorized representative.
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: '0in',
            marginRight: '0in',
            marginBottom: '.25in',
            marginLeft: '.5in',
            textIndent: '-.25in'
          }}
        >
          <span lang="EN">
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
            </span>
          </span>
          <span lang="EN">
            Describe your request with sufficient detail that allows us to properly understand,
            evaluate, and respond to it.
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: '.5in',
            marginRight: '0in',
            marginBottom: '.25in',
            marginLeft: '0in',
            lineHeight: '150%'
          }}
        >
          <span lang="EN">
            We cannot respond to your request or provide you with personal information if we cannot
            verify your identity or authority to make the request and confirm the personal
            information relates to you.
          </span>
        </p>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN">
            Only you, or a person registered with the California Secretary of State that you
            authorize to act on your behalf, may make a verifiable consumer request related to your
            personal information. You may also make a verifiable consumer request on behalf of your
            minor child.
          </span>
        </p>
        <h3
          style={{
            marginTop: '14.0pt',
            marginRight: '0in',
            marginBottom: '.0001pt',
            marginLeft: '0in',
            pageBreakAfter: 'auto'
          }}
        >
          <a name="_j6414ib7tiuz" />
          <b>
            <span lang="EN" style={{ fontSize: '13.0pt', lineHeight: '115%', color: 'black' }}>
              Non-Discrimination
            </span>
          </b>
        </h3>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN">
            We will not discriminate against you for exercising any of your CCPA rights. Unless
            permitted by the CCPA, we will not: (i) deny you goods or services; (ii) charge you
            different prices or rates for goods or services, including through granting discounts or
            other benefits, or imposing penalties; (iii) provide you a different level or quality of
            goods or services; or (iv) suggest that you may receive a different price or rate for
            goods or services or a different level or quality of goods or services.
          </span>
        </p>
        <h3
          style={{
            marginTop: '14.0pt',
            marginRight: '0in',
            marginBottom: '.0001pt',
            marginLeft: '0in',
            pageBreakAfter: 'auto'
          }}
        >
          <a name="_nen79nukb5ra" />
          <b>
            <span lang="EN" style={{ fontSize: '13.0pt', lineHeight: '115%', color: 'black' }}>
              Selling Your Personal Information
            </span>
          </b>
        </h3>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN">
            We do not sell, and have not sold your personal information to third parties for a
            business or commercial purpose in the 12 months preceding the effective date of this
            Privacy Policy, as we understand the term &quot;sell&quot; to mean under the CCPA.
          </span>
        </p>
        <h3
          style={{
            marginTop: '14.0pt',
            marginRight: '0in',
            marginBottom: '.0001pt',
            marginLeft: '0in',
            pageBreakAfter: 'auto'
          }}
        >
          <a name="_rbe3cbj8zhz" />
          <b>
            <span lang="EN" style={{ fontSize: '13.0pt', lineHeight: '115%', color: 'black' }}>
              Personal Information we Collect, Use and Disclose
            </span>
          </b>
        </h3>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN">
            The CCPA specifies categories of personal information protected under the CCPA. The
            following chart provides information about the personal information we collect relative
            to each category and the sources from which we collect such data. For additional
            information regarding the personal information we collect and have collected in the 12
            months preceding the effective date of our Privacy Policy see the heading "
            <span style={{ color: '#1155CC' }}>
              <a href="https://www.chess.com/legal/privacy#types_of_data">
                <span style={{ color: '#1155CC', textDecoration: 'none' }}>
                  Types of Data Collected
                </span>
              </a>
            </span>
            " of our Privacy Policy. We may use personal information for the business/commercial
            purposes described under the heading "
            <span style={{ color: '#1155CC' }}>
              <a href="https://www.chess.com/legal/privacy#use_of_data">
                <span style={{ color: '#1155CC', textDecoration: 'none' }}>Use of Data</span>
              </a>
            </span>
            " of our Privacy Policy. For information about how we share your personal information
            see the headings"
            <span style={{ color: '#1155CC' }}>
              <a href="https://www.chess.com/legal/privacy#disclosure_of_data">
                <span style={{ color: '#1155CC', textDecoration: 'none' }}>Disclosure of Data</span>
              </a>
            </span>
            ", "
            <span style={{ color: '#1155CC' }}>
              <a href="https://www.chess.com/legal/privacy#service_providers">
                <span style={{ color: '#1155CC', textDecoration: 'none' }}>Service Providers</span>
              </a>
            </span>
            ", "
            <span style={{ color: '#1155CC' }}>
              <a href="https://www.chess.com/legal/privacy#analytics">
                <span style={{ color: '#1155CC', textDecoration: 'none' }}>Analytics</span>
              </a>
            </span>
            " and "
            <span style={{ color: '#1155CC' }}>
              <a href="https://www.chess.com/legal/privacy#adv_cookies">
                <span style={{ color: '#1155CC', textDecoration: 'none' }}>Advertising</span>
              </a>
            </span>
            " of our Privacy Policy.
          </span>
        </p>
        <table
          className="a"
          border={0}
          cellSpacing={0}
          cellPadding={0}
          width={0}
          style={{ borderCollapse: 'collapse' }}
        >
          <tbody>
            <tr style={{ height: '39.0pt' }}>
              <td
                valign="top"
                style={{
                  border: 'solid black 1.0pt',
                  padding: '5.0pt 5.0pt 5.0pt 5.0pt',
                  height: '39.0pt'
                }}
              >
                <p className="MsoNormal">
                  <b>
                    <span lang="EN" style={{ fontSize: '9.0pt', lineHeight: '115%' }}>
                      Personal Information Category
                    </span>
                  </b>
                </p>
              </td>
              <td
                valign="top"
                style={{
                  border: 'solid black 1.0pt',
                  borderLeft: 'none',
                  padding: '5.0pt 5.0pt 5.0pt 5.0pt',
                  height: '39.0pt'
                }}
              >
                <p className="MsoNormal">
                  <b>
                    <span lang="EN" style={{ fontSize: '9.0pt', lineHeight: '115%' }}>
                      PI we collect in this Category
                    </span>
                  </b>
                </p>
              </td>
              <td
                valign="top"
                style={{
                  border: 'solid black 1.0pt',
                  borderLeft: 'none',
                  padding: '5.0pt 5.0pt 5.0pt 5.0pt',
                  height: '39.0pt'
                }}
              >
                <p className="MsoNormal">
                  <b>
                    <span lang="EN" style={{ fontSize: '9.0pt', lineHeight: '115%' }}>
                      Sources of PI
                    </span>
                  </b>
                </p>
              </td>
            </tr>
            <tr style={{ height: '148.5pt' }}>
              <td
                valign="top"
                style={{
                  border: 'solid black 1.0pt',
                  borderTop: 'none',
                  padding: '5.0pt 5.0pt 5.0pt 5.0pt',
                  height: '148.5pt'
                }}
              >
                <ol style={{ marginTop: '0in' }} start={1} type={1}>
                  <li className="MsoNormal" style={{ marginTop: '17.0pt', marginBottom: '17.0pt' }}>
                    <span lang="EN" style={{ fontSize: '9.0pt', lineHeight: '115%' }}>
                      Identifiers
                    </span>
                  </li>
                </ol>
              </td>
              <td
                valign="top"
                style={{
                  borderTop: 'none',
                  borderLeft: 'none',
                  borderBottom: 'solid black 1.0pt',
                  borderRight: 'solid black 1.0pt',
                  padding: '5.0pt 5.0pt 5.0pt 5.0pt',
                  height: '148.5pt'
                }}
              >
                <p
                  className="MsoNormal"
                  style={{
                    marginTop: '17.0pt',
                    marginRight: '0in',
                    marginBottom: '.0001pt',
                    marginLeft: '.5in',
                    textIndent: '-.25in'
                  }}
                >
                  <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%' }}>
                    ●
                    <span style={{ font: '7.0pt "Times New Roman"' }}>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    </span>
                  </span>
                  <span lang="EN" style={{ fontSize: '9.0pt', lineHeight: '115%' }}>
                    A real name or alias
                  </span>
                </p>
                <p className="MsoNormal" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
                  <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%' }}>
                    ●
                    <span style={{ font: '7.0pt "Times New Roman"' }}>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    </span>
                  </span>
                  <span lang="EN" style={{ fontSize: '9.0pt', lineHeight: '115%' }}>
                    Internet Protocol address(es)
                  </span>
                </p>
                <p className="MsoNormal" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
                  <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%' }}>
                    ●
                    <span style={{ font: '7.0pt "Times New Roman"' }}>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    </span>
                  </span>
                  <span lang="EN" style={{ fontSize: '9.0pt', lineHeight: '115%' }}>
                    Email address
                  </span>
                </p>
                <p className="MsoNormal" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
                  <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%' }}>
                    ●
                    <span style={{ font: '7.0pt "Times New Roman"' }}>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    </span>
                  </span>
                  <span lang="EN" style={{ fontSize: '9.0pt', lineHeight: '115%' }}>
                    Account name (username), or other similar identifier
                  </span>
                </p>
                <p className="MsoNormal" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
                  <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%' }}>
                    ●
                    <span style={{ font: '7.0pt "Times New Roman"' }}>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    </span>
                  </span>
                  <span lang="EN" style={{ fontSize: '9.0pt', lineHeight: '115%' }}>
                    Mobile push tokens
                  </span>
                </p>
                <p
                  className="MsoNormal"
                  style={{
                    marginTop: '0in',
                    marginRight: '0in',
                    marginBottom: '17.0pt',
                    marginLeft: '.5in',
                    textIndent: '-.25in'
                  }}
                >
                  <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%' }}>
                    ●
                    <span style={{ font: '7.0pt "Times New Roman"' }}>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    </span>
                  </span>
                  <span lang="EN" style={{ fontSize: '9.0pt', lineHeight: '115%' }}>
                    Specific third-party identifiers relating to chess services (e.g., USCF or FIDE
                    ID number) may be collected for some accounts
                  </span>
                </p>
              </td>
              <td
                valign="top"
                style={{
                  borderTop: 'none',
                  borderLeft: 'none',
                  borderBottom: 'solid black 1.0pt',
                  borderRight: 'solid black 1.0pt',
                  padding: '5.0pt 5.0pt 5.0pt 5.0pt',
                  height: '148.5pt'
                }}
              >
                <p
                  className="MsoNormal"
                  style={{
                    marginTop: '17.0pt',
                    marginRight: '0in',
                    marginBottom: '.0001pt',
                    marginLeft: '.5in',
                    textIndent: '-.25in'
                  }}
                >
                  <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%' }}>
                    ●
                    <span style={{ font: '7.0pt "Times New Roman"' }}>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    </span>
                  </span>
                  <span lang="EN" style={{ fontSize: '9.0pt', lineHeight: '115%' }}>
                    Information you provide us
                  </span>
                </p>
                <p className="MsoNormal" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
                  <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%' }}>
                    ●
                    <span style={{ font: '7.0pt "Times New Roman"' }}>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    </span>
                  </span>
                  <span lang="EN" style={{ fontSize: '9.0pt', lineHeight: '115%' }}>
                    Information we collect from you automatically
                  </span>
                </p>
                <p
                  className="MsoNormal"
                  style={{
                    marginTop: '0in',
                    marginRight: '0in',
                    marginBottom: '17.0pt',
                    marginLeft: '.5in',
                    textIndent: '-.25in'
                  }}
                >
                  <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%' }}>
                    ●
                    <span style={{ font: '7.0pt "Times New Roman"' }}>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    </span>
                  </span>
                  <span lang="EN" style={{ fontSize: '9.0pt', lineHeight: '115%' }}>
                    3rd Party Service Provider
                  </span>
                </p>
              </td>
            </tr>
            <tr style={{ height: '101.25pt' }}>
              <td
                valign="top"
                style={{
                  border: 'solid black 1.0pt',
                  borderTop: 'none',
                  padding: '5.0pt 5.0pt 5.0pt 5.0pt',
                  height: '101.25pt'
                }}
              >
                <ol style={{ marginTop: '0in' }} start={2} type={1}>
                  <li className="MsoNormal" style={{ marginTop: '17.0pt', marginBottom: '17.0pt' }}>
                    <span lang="EN" style={{ fontSize: '9.0pt', lineHeight: '115%' }}>
                      Personal information categories listed in the California Customer Records
                      statute (Cal. Civ. Code &quot; 1798.80(e))
                    </span>
                  </li>
                </ol>
              </td>
              <td
                valign="top"
                style={{
                  borderTop: 'none',
                  borderLeft: 'none',
                  borderBottom: 'solid black 1.0pt',
                  borderRight: 'solid black 1.0pt',
                  padding: '5.0pt 5.0pt 5.0pt 5.0pt',
                  height: '101.25pt'
                }}
              >
                <p
                  className="MsoNormal"
                  style={{
                    marginTop: '17.0pt',
                    marginRight: '0in',
                    marginBottom: '17.0pt',
                    marginLeft: '.5in',
                    textIndent: '-.25in'
                  }}
                >
                  <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%' }}>
                    ●
                    <span style={{ font: '7.0pt "Times New Roman"' }}>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    </span>
                  </span>
                  <span lang="EN" style={{ fontSize: '9.0pt', lineHeight: '115%' }}>
                    not applicable
                  </span>
                </p>
              </td>
              <td
                valign="top"
                style={{
                  borderTop: 'none',
                  borderLeft: 'none',
                  borderBottom: 'solid black 1.0pt',
                  borderRight: 'solid black 1.0pt',
                  padding: '5.0pt 5.0pt 5.0pt 5.0pt',
                  height: '101.25pt'
                }}
              >
                <p
                  className="MsoNormal"
                  style={{
                    marginTop: '17.0pt',
                    marginRight: '0in',
                    marginBottom: '17.0pt',
                    marginLeft: '.5in',
                    textIndent: '-.25in'
                  }}
                >
                  <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%' }}>
                    ●
                    <span style={{ font: '7.0pt "Times New Roman"' }}>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    </span>
                  </span>
                  <span lang="EN" style={{ fontSize: '9.0pt', lineHeight: '115%' }}>
                    not applicable
                  </span>
                </p>
              </td>
            </tr>
            <tr style={{ height: '70.5pt' }}>
              <td
                valign="top"
                style={{
                  border: 'solid black 1.0pt',
                  borderTop: 'none',
                  padding: '5.0pt 5.0pt 5.0pt 5.0pt',
                  height: '70.5pt'
                }}
              >
                <ol style={{ marginTop: '0in' }} start={3} type={1}>
                  <li className="MsoNormal" style={{ marginTop: '17.0pt', marginBottom: '17.0pt' }}>
                    <span lang="EN" style={{ fontSize: '9.0pt', lineHeight: '115%' }}>
                      Protected classification characteristics under California or federal law
                    </span>
                  </li>
                </ol>
              </td>
              <td
                valign="top"
                style={{
                  borderTop: 'none',
                  borderLeft: 'none',
                  borderBottom: 'solid black 1.0pt',
                  borderRight: 'solid black 1.0pt',
                  padding: '5.0pt 5.0pt 5.0pt 5.0pt',
                  height: '70.5pt'
                }}
              >
                <p
                  className="MsoNormal"
                  style={{
                    marginTop: '17.0pt',
                    marginRight: '0in',
                    marginBottom: '17.0pt',
                    marginLeft: '.5in',
                    textIndent: '-.25in'
                  }}
                >
                  <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%' }}>
                    ●
                    <span style={{ font: '7.0pt "Times New Roman"' }}>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    </span>
                  </span>
                  <span lang="EN" style={{ fontSize: '9.0pt', lineHeight: '115%' }}>
                    not applicable
                  </span>
                </p>
              </td>
              <td
                valign="top"
                style={{
                  borderTop: 'none',
                  borderLeft: 'none',
                  borderBottom: 'solid black 1.0pt',
                  borderRight: 'solid black 1.0pt',
                  padding: '5.0pt 5.0pt 5.0pt 5.0pt',
                  height: '70.5pt'
                }}
              >
                <p
                  className="MsoNormal"
                  style={{
                    marginTop: '17.0pt',
                    marginRight: '0in',
                    marginBottom: '17.0pt',
                    marginLeft: '.5in',
                    textIndent: '-.25in'
                  }}
                >
                  <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%' }}>
                    ●
                    <span style={{ font: '7.0pt "Times New Roman"' }}>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    </span>
                  </span>
                  <span lang="EN" style={{ fontSize: '9.0pt', lineHeight: '115%' }}>
                    not applicable
                  </span>
                </p>
              </td>
            </tr>
            <tr style={{ height: '40.5pt' }}>
              <td
                valign="top"
                style={{
                  border: 'solid black 1.0pt',
                  borderTop: 'none',
                  padding: '5.0pt 5.0pt 5.0pt 5.0pt',
                  height: '40.5pt'
                }}
              >
                <ol style={{ marginTop: '0in' }} start={4} type={1}>
                  <li className="MsoNormal" style={{ marginTop: '17.0pt', marginBottom: '17.0pt' }}>
                    <span lang="EN" style={{ fontSize: '9.0pt', lineHeight: '115%' }}>
                      Commercial information
                    </span>
                  </li>
                </ol>
              </td>
              <td
                valign="top"
                style={{
                  borderTop: 'none',
                  borderLeft: 'none',
                  borderBottom: 'solid black 1.0pt',
                  borderRight: 'solid black 1.0pt',
                  padding: '5.0pt 5.0pt 5.0pt 5.0pt',
                  height: '40.5pt'
                }}
              >
                <p
                  className="MsoNormal"
                  style={{
                    marginTop: '17.0pt',
                    marginRight: '0in',
                    marginBottom: '17.0pt',
                    marginLeft: '.5in',
                    textIndent: '-.25in'
                  }}
                >
                  <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%' }}>
                    ●
                    <span style={{ font: '7.0pt "Times New Roman"' }}>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    </span>
                  </span>
                  <span lang="EN" style={{ fontSize: '9.0pt', lineHeight: '115%' }}>
                    not applicable
                  </span>
                </p>
              </td>
              <td
                valign="top"
                style={{
                  borderTop: 'none',
                  borderLeft: 'none',
                  borderBottom: 'solid black 1.0pt',
                  borderRight: 'solid black 1.0pt',
                  padding: '5.0pt 5.0pt 5.0pt 5.0pt',
                  height: '40.5pt'
                }}
              >
                <p
                  className="MsoNormal"
                  style={{
                    marginTop: '17.0pt',
                    marginRight: '0in',
                    marginBottom: '17.0pt',
                    marginLeft: '.5in',
                    textIndent: '-.25in'
                  }}
                >
                  <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%' }}>
                    ●
                    <span style={{ font: '7.0pt "Times New Roman"' }}>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    </span>
                  </span>
                  <span lang="EN" style={{ fontSize: '9.0pt', lineHeight: '115%' }}>
                    not applicable
                  </span>
                </p>
              </td>
            </tr>
            <tr style={{ height: '48.0pt' }}>
              <td
                valign="top"
                style={{
                  border: 'solid black 1.0pt',
                  borderTop: 'none',
                  padding: '5.0pt 5.0pt 5.0pt 5.0pt',
                  height: '48.0pt'
                }}
              >
                <ol style={{ marginTop: '0in' }} start={5} type={1}>
                  <li className="MsoNormal" style={{ marginTop: '17.0pt', marginBottom: '17.0pt' }}>
                    <span lang="EN" style={{ fontSize: '9.0pt', lineHeight: '115%' }}>
                      Biometric information
                    </span>
                  </li>
                </ol>
              </td>
              <td
                valign="top"
                style={{
                  borderTop: 'none',
                  borderLeft: 'none',
                  borderBottom: 'solid black 1.0pt',
                  borderRight: 'solid black 1.0pt',
                  padding: '5.0pt 5.0pt 5.0pt 5.0pt',
                  height: '48.0pt'
                }}
              >
                <p
                  className="MsoNormal"
                  style={{
                    marginTop: '17.0pt',
                    marginRight: '0in',
                    marginBottom: '17.0pt',
                    marginLeft: '.5in',
                    textIndent: '-.25in'
                  }}
                >
                  <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%' }}>
                    ●
                    <span style={{ font: '7.0pt "Times New Roman"' }}>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    </span>
                  </span>
                  <span lang="EN" style={{ fontSize: '9.0pt', lineHeight: '115%' }}>
                    not applicable
                  </span>
                </p>
              </td>
              <td
                valign="top"
                style={{
                  borderTop: 'none',
                  borderLeft: 'none',
                  borderBottom: 'solid black 1.0pt',
                  borderRight: 'solid black 1.0pt',
                  padding: '5.0pt 5.0pt 5.0pt 5.0pt',
                  height: '48.0pt'
                }}
              >
                <p
                  className="MsoNormal"
                  style={{
                    marginTop: '17.0pt',
                    marginRight: '0in',
                    marginBottom: '17.0pt',
                    marginLeft: '.5in',
                    textIndent: '-.25in'
                  }}
                >
                  <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%' }}>
                    ●
                    <span style={{ font: '7.0pt "Times New Roman"' }}>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    </span>
                  </span>
                  <span lang="EN" style={{ fontSize: '9.0pt', lineHeight: '115%' }}>
                    not applicable
                  </span>
                </p>
              </td>
            </tr>
            <tr style={{ height: '60.0pt' }}>
              <td
                valign="top"
                style={{
                  border: 'solid black 1.0pt',
                  borderTop: 'none',
                  padding: '5.0pt 5.0pt 5.0pt 5.0pt',
                  height: '60.0pt'
                }}
              >
                <ol style={{ marginTop: '0in' }} start={6} type={1}>
                  <li className="MsoNormal" style={{ marginTop: '17.0pt', marginBottom: '17.0pt' }}>
                    <span lang="EN" style={{ fontSize: '9.0pt', lineHeight: '115%' }}>
                      Internet or other similar network activity
                    </span>
                  </li>
                </ol>
              </td>
              <td
                valign="top"
                style={{
                  borderTop: 'none',
                  borderLeft: 'none',
                  borderBottom: 'solid black 1.0pt',
                  borderRight: 'solid black 1.0pt',
                  padding: '5.0pt 5.0pt 5.0pt 5.0pt',
                  height: '60.0pt'
                }}
              >
                <p
                  className="MsoNormal"
                  style={{
                    marginTop: '17.0pt',
                    marginRight: '0in',
                    marginBottom: '17.0pt',
                    marginLeft: '.5in',
                    textIndent: '-.25in'
                  }}
                >
                  <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%' }}>
                    ●
                    <span style={{ font: '7.0pt "Times New Roman"' }}>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    </span>
                  </span>
                  <span lang="EN" style={{ fontSize: '9.0pt', lineHeight: '115%' }}>
                    Browsing history on chessx.app only
                  </span>
                </p>
              </td>
              <td
                valign="top"
                style={{
                  borderTop: 'none',
                  borderLeft: 'none',
                  borderBottom: 'solid black 1.0pt',
                  borderRight: 'solid black 1.0pt',
                  padding: '5.0pt 5.0pt 5.0pt 5.0pt',
                  height: '60.0pt'
                }}
              >
                <p
                  className="MsoNormal"
                  style={{
                    marginTop: '17.0pt',
                    marginRight: '0in',
                    marginBottom: '.0001pt',
                    marginLeft: '.5in',
                    textIndent: '-.25in'
                  }}
                >
                  <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%' }}>
                    ●
                    <span style={{ font: '7.0pt "Times New Roman"' }}>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    </span>
                  </span>
                  <span lang="EN" style={{ fontSize: '9.0pt', lineHeight: '115%' }}>
                    Information we collect from you automatically
                  </span>
                </p>
                <p
                  className="MsoNormal"
                  style={{
                    marginTop: '0in',
                    marginRight: '0in',
                    marginBottom: '17.0pt',
                    marginLeft: '.5in',
                    textIndent: '-.25in'
                  }}
                >
                  <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%' }}>
                    ●
                    <span style={{ font: '7.0pt "Times New Roman"' }}>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    </span>
                  </span>
                  <span lang="EN" style={{ fontSize: '9.0pt', lineHeight: '115%' }}>
                    3rd Party Service Provider
                  </span>
                </p>
              </td>
            </tr>
            <tr style={{ height: '41.25pt' }}>
              <td
                valign="top"
                style={{
                  border: 'solid black 1.0pt',
                  borderTop: 'none',
                  padding: '5.0pt 5.0pt 5.0pt 5.0pt',
                  height: '41.25pt'
                }}
              >
                <ol style={{ marginTop: '0in' }} start={7} type={1}>
                  <li className="MsoNormal" style={{ marginTop: '17.0pt', marginBottom: '17.0pt' }}>
                    <span lang="EN" style={{ fontSize: '9.0pt', lineHeight: '115%' }}>
                      Geolocation data
                    </span>
                  </li>
                </ol>
              </td>
              <td
                valign="top"
                style={{
                  borderTop: 'none',
                  borderLeft: 'none',
                  borderBottom: 'solid black 1.0pt',
                  borderRight: 'solid black 1.0pt',
                  padding: '5.0pt 5.0pt 5.0pt 5.0pt',
                  height: '41.25pt'
                }}
              >
                <p
                  className="MsoNormal"
                  style={{
                    marginTop: '17.0pt',
                    marginRight: '0in',
                    marginBottom: '17.0pt',
                    marginLeft: '.5in',
                    textIndent: '-.25in'
                  }}
                >
                  <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%' }}>
                    ●
                    <span style={{ font: '7.0pt "Times New Roman"' }}>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    </span>
                  </span>
                  <span lang="EN" style={{ fontSize: '9.0pt', lineHeight: '115%' }}>
                    not applicable
                  </span>
                </p>
              </td>
              <td
                valign="top"
                style={{
                  borderTop: 'none',
                  borderLeft: 'none',
                  borderBottom: 'solid black 1.0pt',
                  borderRight: 'solid black 1.0pt',
                  padding: '5.0pt 5.0pt 5.0pt 5.0pt',
                  height: '41.25pt'
                }}
              >
                <p
                  className="MsoNormal"
                  style={{
                    marginTop: '17.0pt',
                    marginRight: '0in',
                    marginBottom: '17.0pt',
                    marginLeft: '.5in',
                    textIndent: '-.25in'
                  }}
                >
                  <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%' }}>
                    ●
                    <span style={{ font: '7.0pt "Times New Roman"' }}>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    </span>
                  </span>
                  <span lang="EN" style={{ fontSize: '9.0pt', lineHeight: '115%' }}>
                    not applicable
                  </span>
                </p>
              </td>
            </tr>
            <tr style={{ height: '39.0pt' }}>
              <td
                valign="top"
                style={{
                  border: 'solid black 1.0pt',
                  borderTop: 'none',
                  padding: '5.0pt 5.0pt 5.0pt 5.0pt',
                  height: '39.0pt'
                }}
              >
                <ol style={{ marginTop: '0in' }} start={8} type={1}>
                  <li className="MsoNormal" style={{ marginTop: '17.0pt', marginBottom: '17.0pt' }}>
                    <span lang="EN" style={{ fontSize: '9.0pt', lineHeight: '115%' }}>
                      Sensory data
                    </span>
                  </li>
                </ol>
              </td>
              <td
                valign="top"
                style={{
                  borderTop: 'none',
                  borderLeft: 'none',
                  borderBottom: 'solid black 1.0pt',
                  borderRight: 'solid black 1.0pt',
                  padding: '5.0pt 5.0pt 5.0pt 5.0pt',
                  height: '39.0pt'
                }}
              >
                <p
                  className="MsoNormal"
                  style={{
                    marginTop: '17.0pt',
                    marginRight: '0in',
                    marginBottom: '17.0pt',
                    marginLeft: '.5in',
                    textIndent: '-.25in'
                  }}
                >
                  <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%' }}>
                    ●
                    <span style={{ font: '7.0pt "Times New Roman"' }}>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    </span>
                  </span>
                  <span lang="EN" style={{ fontSize: '9.0pt', lineHeight: '115%' }}>
                    not applicable
                  </span>
                </p>
              </td>
              <td
                valign="top"
                style={{
                  borderTop: 'none',
                  borderLeft: 'none',
                  borderBottom: 'solid black 1.0pt',
                  borderRight: 'solid black 1.0pt',
                  padding: '5.0pt 5.0pt 5.0pt 5.0pt',
                  height: '39.0pt'
                }}
              >
                <p
                  className="MsoNormal"
                  style={{
                    marginTop: '17.0pt',
                    marginRight: '0in',
                    marginBottom: '17.0pt',
                    marginLeft: '.5in',
                    textIndent: '-.25in'
                  }}
                >
                  <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%' }}>
                    ●
                    <span style={{ font: '7.0pt "Times New Roman"' }}>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    </span>
                  </span>
                  <span lang="EN" style={{ fontSize: '9.0pt', lineHeight: '115%' }}>
                    not applicable
                  </span>
                </p>
              </td>
            </tr>
            <tr style={{ height: '52.5pt' }}>
              <td
                valign="top"
                style={{
                  border: 'solid black 1.0pt',
                  borderTop: 'none',
                  padding: '5.0pt 5.0pt 5.0pt 5.0pt',
                  height: '52.5pt'
                }}
              >
                <ol style={{ marginTop: '0in' }} start={9} type={1}>
                  <li className="MsoNormal" style={{ marginTop: '17.0pt', marginBottom: '17.0pt' }}>
                    <span lang="EN" style={{ fontSize: '9.0pt', lineHeight: '115%' }}>
                      Professional or employment-related information
                    </span>
                  </li>
                </ol>
              </td>
              <td
                valign="top"
                style={{
                  borderTop: 'none',
                  borderLeft: 'none',
                  borderBottom: 'solid black 1.0pt',
                  borderRight: 'solid black 1.0pt',
                  padding: '5.0pt 5.0pt 5.0pt 5.0pt',
                  height: '52.5pt'
                }}
              >
                <p
                  className="MsoNormal"
                  style={{
                    marginTop: '17.0pt',
                    marginRight: '0in',
                    marginBottom: '17.0pt',
                    marginLeft: '.5in',
                    textIndent: '-.25in'
                  }}
                >
                  <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%' }}>
                    ●
                    <span style={{ font: '7.0pt "Times New Roman"' }}>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    </span>
                  </span>
                  <span lang="EN" style={{ fontSize: '9.0pt', lineHeight: '115%' }}>
                    not applicable
                  </span>
                </p>
              </td>
              <td
                valign="top"
                style={{
                  borderTop: 'none',
                  borderLeft: 'none',
                  borderBottom: 'solid black 1.0pt',
                  borderRight: 'solid black 1.0pt',
                  padding: '5.0pt 5.0pt 5.0pt 5.0pt',
                  height: '52.5pt'
                }}
              >
                <p
                  className="MsoNormal"
                  style={{
                    marginTop: '17.0pt',
                    marginRight: '0in',
                    marginBottom: '17.0pt',
                    marginLeft: '.5in',
                    textIndent: '-.25in'
                  }}
                >
                  <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%' }}>
                    ●
                    <span style={{ font: '7.0pt "Times New Roman"' }}>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    </span>
                  </span>
                  <span lang="EN" style={{ fontSize: '9.0pt', lineHeight: '115%' }}>
                    not applicable
                  </span>
                </p>
              </td>
            </tr>
            <tr style={{ height: '142.95pt' }}>
              <td
                valign="top"
                style={{
                  border: 'solid black 1.0pt',
                  borderTop: 'none',
                  padding: '5.0pt 5.0pt 5.0pt 5.0pt',
                  height: '142.95pt'
                }}
              >
                <ol style={{ marginTop: '0in' }} start={10} type={1}>
                  <li className="MsoNormal" style={{ marginTop: '17.0pt', marginBottom: '17.0pt' }}>
                    <span lang="EN" style={{ fontSize: '9.0pt', lineHeight: '115%' }}>
                      Non-public education information (per the Family Educational Rights and
                      Privacy Act (20 U.S.C. Section 1232g, 34 C.F.R. Part 99))
                    </span>
                  </li>
                </ol>
              </td>
              <td
                valign="top"
                style={{
                  borderTop: 'none',
                  borderLeft: 'none',
                  borderBottom: 'solid black 1.0pt',
                  borderRight: 'solid black 1.0pt',
                  padding: '5.0pt 5.0pt 5.0pt 5.0pt',
                  height: '142.95pt'
                }}
              >
                <p
                  className="MsoNormal"
                  style={{
                    marginTop: '17.0pt',
                    marginRight: '0in',
                    marginBottom: '17.0pt',
                    marginLeft: '.5in',
                    textIndent: '-.25in'
                  }}
                >
                  <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%' }}>
                    ●
                    <span style={{ font: '7.0pt "Times New Roman"' }}>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    </span>
                  </span>
                  <span lang="EN" style={{ fontSize: '9.0pt', lineHeight: '115%' }}>
                    not applicable
                  </span>
                </p>
              </td>
              <td
                valign="top"
                style={{
                  borderTop: 'none',
                  borderLeft: 'none',
                  borderBottom: 'solid black 1.0pt',
                  borderRight: 'solid black 1.0pt',
                  padding: '5.0pt 5.0pt 5.0pt 5.0pt',
                  height: '142.95pt'
                }}
              >
                <p
                  className="MsoNormal"
                  style={{
                    marginTop: '17.0pt',
                    marginRight: '0in',
                    marginBottom: '17.0pt',
                    marginLeft: '.5in',
                    textIndent: '-.25in'
                  }}
                >
                  <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%' }}>
                    ●
                    <span style={{ font: '7.0pt "Times New Roman"' }}>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    </span>
                  </span>
                  <span lang="EN" style={{ fontSize: '9.0pt', lineHeight: '115%' }}>
                    not applicable
                  </span>
                </p>
              </td>
            </tr>
            <tr style={{ height: '48.0pt' }}>
              <td
                valign="top"
                style={{
                  border: 'solid black 1.0pt',
                  borderTop: 'none',
                  padding: '5.0pt 5.0pt 5.0pt 5.0pt',
                  height: '48.0pt'
                }}
              >
                <ol style={{ marginTop: '0in' }} start={11} type={1}>
                  <li className="MsoNormal" style={{ marginTop: '17.0pt', marginBottom: '17.0pt' }}>
                    <span lang="EN" style={{ fontSize: '9.0pt', lineHeight: '115%' }}>
                      Inferences drawn from other personal information
                    </span>
                  </li>
                </ol>
              </td>
              <td
                valign="top"
                style={{
                  borderTop: 'none',
                  borderLeft: 'none',
                  borderBottom: 'solid black 1.0pt',
                  borderRight: 'solid black 1.0pt',
                  padding: '5.0pt 5.0pt 5.0pt 5.0pt',
                  height: '48.0pt'
                }}
              >
                <p
                  className="MsoNormal"
                  style={{
                    marginTop: '17.0pt',
                    marginRight: '0in',
                    marginBottom: '17.0pt',
                    marginLeft: '.5in',
                    textIndent: '-.25in'
                  }}
                >
                  <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%' }}>
                    ●
                    <span style={{ font: '7.0pt "Times New Roman"' }}>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    </span>
                  </span>
                  <span lang="EN" style={{ fontSize: '9.0pt', lineHeight: '115%' }}>
                    not applicable
                  </span>
                </p>
              </td>
              <td
                valign="top"
                style={{
                  borderTop: 'none',
                  borderLeft: 'none',
                  borderBottom: 'solid black 1.0pt',
                  borderRight: 'solid black 1.0pt',
                  padding: '5.0pt 5.0pt 5.0pt 5.0pt',
                  height: '48.0pt'
                }}
              >
                <p
                  className="MsoNormal"
                  style={{
                    marginTop: '17.0pt',
                    marginRight: '0in',
                    marginBottom: '17.0pt',
                    marginLeft: '.5in',
                    textIndent: '-.25in'
                  }}
                >
                  <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%' }}>
                    ●
                    <span style={{ font: '7.0pt "Times New Roman"' }}>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    </span>
                  </span>
                  <span lang="EN" style={{ fontSize: '9.0pt', lineHeight: '115%' }}>
                    not applicable
                  </span>
                </p>
              </td>
            </tr>
          </tbody>
        </table>
        <h2 style={{ marginBottom: '.0001pt', pageBreakAfter: 'auto' }}>
          <a name="_8aciflh6sla0" />
          <b>
            <span lang="EN" style={{ fontSize: '17.0pt', lineHeight: '115%' }}>
              CONTACT INFORMATION
            </span>
          </b>
        </h2>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN">
            If you have any questions or comments about this notice or the ways in which ChessX,
            Inc. collects and uses your information as described in the <b>Privacy Policy</b> or you
            wish to exercise your rights under California law, please do not hesitate to contact us
            at:
          </span>
        </p>
        <p className="MsoNormal">
          <b>
            <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%' }}>
              Phone:
            </span>
          </b>
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%' }}>
            {' '}
            1 (857) 222-6262
          </span>
        </p>
        <p className="MsoNormal">
          <b>
            <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%' }}>
              Email:
            </span>
          </b>
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%' }}>
            {' '}
            contact@chessx.app
          </span>
        </p>
        <p className="MsoNormal">
          <b>
            <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%' }}>
              Postal Address:
            </span>
          </b>
        </p>
        <p className="MsoNormal">
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%' }}>
            ChessX, Inc.
          </span>
        </p>
        <p className="MsoNormal">
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%' }}>
            137 Erie Street
          </span>
        </p>
        <p className="MsoNormal">
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%' }}>
            Cambridge, MA 02139
          </span>
        </p>
        <h2 style={{ marginBottom: '.0001pt', pageBreakAfter: 'auto' }}>
          <a name="_ru950n1n83ft" />
          <b>
            <span lang="EN" style={{ fontSize: '17.0pt', lineHeight: '115%' }}>
              CHANGES TO THIS PRIVACY POLICY NOTICE
            </span>
          </b>
        </h2>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN">
            We reserve the right to amend our Privacy Policy at our discretion and at any time. When
            we make changes to our Privacy Policy, we will (i) let you know via email and/or a
            prominent notice on our Services and (ii) post the updated Privacy Policy on the website
            and update the Privacy Policy's effective date. You are advised to review this Privacy
            Policy periodically for any changes.
          </span>
        </p>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <b>
            <span lang="EN">
              Your continued use of our website following the posting of changes constitutes your
              acceptance of such changes.
            </span>
          </b>
        </p>
        <div className="MsoNormal" style={{ textAlign: 'center' }}>
          <span lang="EN">
            <hr size={3} width="100%" align="center" />
          </span>
        </div>
        <h2 style={{ marginBottom: '.0001pt', pageBreakAfter: 'auto' }}>
          <a name="_smg70gue3fhc" />
          <b>
            <span lang="EN" style={{ fontSize: '17.0pt', lineHeight: '115%' }}>
              Privacy Policy for Chess - Play &amp; Learn (Arcade Version)
            </span>
          </b>
        </h2>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN">
            This section states our policy on the collection, use, and disclosure of data collected
            by the app, Chess - Play &amp; Learn (Arcade Version), hereafter &quot;the app.&quot; It is not
            broadly applicable to the ChessX website or its other apps.
          </span>
        </p>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN">
            We do not collect any personal information through the app, but please review this
            policy for more detail on what kind of information may be collected, used and/or stored.
          </span>
        </p>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN">
            If you choose to use the app, then you agree to the collection and use of information in
            relation to this policy. The information that we collect is used for supporting game
            services and improving the app. We will not use or share your information with anyone
            except as described in this Privacy Policy.
          </span>
        </p>
        <h2 style={{ marginBottom: '.0001pt', pageBreakAfter: 'auto' }}>
          <a name="_w34yzegu9l6c" />
          <b>
            <span lang="EN" style={{ fontSize: '17.0pt', lineHeight: '115%' }}>
              Data Collection and Use
            </span>
          </b>
        </h2>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN">
            The app collects non-identifiable gameplay data to send to Apple iCloud, specifically to
            record a player&quot;s progress (win record) vs the app&quot;s built-in roster of computer
            opponents. We (ChessX, Inc.) do not store any of this data, but it is sent to Apple
            services (iCloud and Game Center) for storage and use.
          </span>
        </p>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN">
            The app also collects the user&quot;s anonymized gamePlayerID for the app&quot;s &quot;Online Play&quot;
            feature, where it is used exclusively to maintain a chess skill rating as online games
            are played. This helps ensure players are matched with opponents of similar skill
            levels. The collection of this data is subject to the user&quot;s explicit permission, as
            requested in the app prior to first use, and can be subsequently terminated at any time
            via the app&quot;s Settings (&quot;Stop Collecting Data&quot;).
          </span>
        </p>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN">
            The app is available to players of all ages through the Apple Arcade service and
            collects this non-identifiable gameplay data from all players without respect to age.
            The basis for this collection of information is to support the internal operations of
            the app as permitted by the Children&quot;s Online Privacy Protection Rule (&quot;COPPA&quot;), which
            is a legitimate use under the General Data Protection Regulation (&quot;GDPR&quot;).
          </span>
        </p>
        <h2 style={{ marginBottom: '.0001pt', pageBreakAfter: 'auto' }}>
          <a name="_6u18yen4ffux" />
          <b>
            <span lang="EN" style={{ fontSize: '17.0pt', lineHeight: '115%' }}>
              Security
            </span>
          </b>
        </h2>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN">
            We employ conventionally acceptable methods to protect all information we obtain from
            our users. However, no method of Internet transmission or of electronic storage is 100%
            secure and reliable, and we cannot absolutely guarantee its security.
          </span>
        </p>
        <h2 style={{ marginBottom: '.0001pt', pageBreakAfter: 'auto' }}>
          <a name="_uudreurw9li" />
          <b>
            <span lang="EN" style={{ fontSize: '17.0pt', lineHeight: '115%' }}>
              Changes to This Privacy Policy
            </span>
          </b>
        </h2>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN">
            We may change our Privacy Policy from time to time, and we will notify you of any
            changes by posting updates to this page. These changes are effective immediately after
            they are posted here.
          </span>
        </p>
        <h2 style={{ marginBottom: '.0001pt', pageBreakAfter: 'auto' }}>
          <a name="_d83tmyrrbtuj" />
          <b>
            <span lang="EN" style={{ fontSize: '17.0pt', lineHeight: '115%' }}>
              Contact Us
            </span>
          </b>
        </h2>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN">
            If you have any questions about our Privacy Policy, please contact us:
          </span>
        </p>
        <p className="MsoNormal">
          <b>
            <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%' }}>
              Phone:
            </span>
          </b>
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%' }}>
            {' '}
            1 (857) 222-6262
          </span>
        </p>
        <p className="MsoNormal">
          <b>
            <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%' }}>
              Email:
            </span>
          </b>
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%' }}>
            {' '}
            contact@chessx.app
          </span>
        </p>
        <p className="MsoNormal">
          <b>
            <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%' }}>
              Postal Address:
            </span>
          </b>
        </p>
        <p className="MsoNormal">
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%' }}>
            ChessX, Inc.
          </span>
        </p>
        <p className="MsoNormal">
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%' }}>
            137 Erie Street
          </span>
        </p>
        <p className="MsoNormal">
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%' }}>
            Cambridge, MA 02139
          </span>
        </p>
      </div>
    </div>
  )
}

export default Privacy
